module.exports = __webpack_public_path__ + "img/af.12810774.png";